    <div>
        <p-steps [model]="menus" [readonly]="false" [(activeIndex)]="activeIndex" class="stepper no-label"></p-steps>
        <div class="card" *ngIf="activeIndex == 0">
            <div class="p-grid" *ngIf="channel && channel != soChannel.CUSTOMER_RETURNS">
                <div class="p-col-6">
                    <h6>Ship From</h6>
                    <p>{{ detailsObj?.warehouse?.name }}</p>
                    <p>
                        {{ detailsObj?.warehouse?.address?.streetAddress1 ?? "" }}
                        {{ detailsObj?.warehouse?.address?.streetAddress1 && detailsObj?.warehouse?.address?.streetAddress1?.length > 0 && detailsObj?.warehouse?.address?.streetAddress2 && detailsObj?.warehouse?.address?.streetAddress2.length > 0 ? "," : "" }}
                        {{ detailsObj?.warehouse?.address?.streetAddress2 ?? "" }}
                    </p>
                    <p> {{ detailsObj?.warehouse?.address?.state?.name }}&nbsp;{{ detailsObj?.warehouse?.address?.city?.name }}&nbsp;{{ detailsObj?.warehouse?.address?.zipCode }} </p>
                    <p>
                        {{ detailsObj?.warehouse?.phoneNo }}
                    </p>
                </div>
                <div class="p-col-6">
                    <h6>Ship To</h6>
                    <!-- <p>{{ detailsObj?.account?.businessName }}</p> -->
                    <p>{{ shippingAddress?.address?.addressName && shippingAddress?.address?.addressName?.length > 0 ? shippingAddress?.address?.addressName : detailsObj?.account?.businessName }}</p>
                    <p>
                        {{ shippingAddress?.address?.streetAddress1 ?? "" }}
                        {{ shippingAddress?.address?.streetAddress1 && shippingAddress?.address?.streetAddress1?.length > 0 && shippingAddress?.address?.streetAddress2 && shippingAddress?.address?.streetAddress2?.length > 0 ? "," : "" }}
                        {{ shippingAddress?.address?.streetAddress2 ?? "" }}
                    </p>
                    <p> {{ shippingAddress?.address?.state?.name }}&nbsp;{{ shippingAddress?.address?.city?.name }}&nbsp;{{ shippingAddress?.address?.zipCode }} </p>
                    <p> {{ shippingAddressContact?.firstName }} {{ shippingAddressContact?.lastName ? " " : "" }} {{ shippingAddressContact?.lastName }} </p>
                    <p>
                        {{ shippingAddressContact && shippingAddressContact?.contactPhones && shippingAddressContact?.contactPhones[0]?.phone && shippingAddressContact?.contactPhones[0]?.phone?.number ? shippingAddressContact?.contactPhones[0]?.phone?.number : "" }}
                    </p>
                </div>
            </div>
            <div class="p-grid" *ngIf="channel && channel == soChannel.CUSTOMER_RETURNS">
                <div class="p-col-6">
                    <h6>Ship From</h6>
                    <!-- <p>{{ detailsObj?.account?.businessName }}</p> -->
                    <p>{{ shippingAddress?.address?.addressName && shippingAddress?.address?.addressName?.length > 0 ? shippingAddress?.address?.addressName : detailsObj?.account?.businessName }}</p>
                    <p>
                        {{ shippingAddress?.address?.streetAddress1 ?? "" }}
                        {{ shippingAddress?.address?.streetAddress1 && shippingAddress?.address?.streetAddress1?.length > 0 && shippingAddress?.address?.streetAddress2 && shippingAddress?.address?.streetAddress2?.length > 0 ? "," : "" }}
                        {{ shippingAddress?.address?.streetAddress2 ?? "" }}
                    </p>
                    <p> {{ shippingAddress?.address?.state?.name }}&nbsp;{{ shippingAddress?.address?.city?.name }}&nbsp;{{ shippingAddress?.address?.zipCode }} </p>
                    <p> {{ shippingAddressContact?.firstName }} {{ shippingAddressContact?.lastName ? " " : "" }} {{ shippingAddressContact?.lastName }} </p>
                    <p>
                        {{ shippingAddressContact && shippingAddressContact?.contactPhones && shippingAddressContact?.contactPhones[0]?.phone && shippingAddressContact?.contactPhones[0]?.phone?.number ? shippingAddressContact?.contactPhones[0]?.phone?.number : "" }}
                    </p>
                </div>
                <div class="p-col-6">
                    <h6>Ship To</h6>
                    <p>{{ detailsObj?.warehouse?.name }}</p>
                    <p>
                        {{ detailsObj?.warehouse?.address?.streetAddress1 ?? "" }}
                        {{ detailsObj?.warehouse?.address?.streetAddress1 && detailsObj?.warehouse?.address?.streetAddress1?.length > 0 && detailsObj?.warehouse?.address?.streetAddress2 && detailsObj?.warehouse?.address?.streetAddress2.length > 0 ? "," : "" }}
                        {{ detailsObj?.warehouse?.address?.streetAddress2 ?? "" }}
                    </p>
                    <p> {{ detailsObj?.warehouse?.address?.state?.name }}&nbsp;{{ detailsObj?.warehouse?.address?.city?.name }}&nbsp;{{ detailsObj?.warehouse?.address?.zipCode }} </p>
                    <p>
                        {{ detailsObj?.warehouse?.phoneNo }}
                    </p>
                </div>
            </div>
        </div>
        <div *ngIf="activeIndex == 1">
            <form [formGroup]="form">
                <ng-container formArrayName="packages">
                    <ng-container *ngFor="let package of packages.controls; let i = index">
                        <div [formGroup]="getFormGroupAt(i)">
                            <p-panel header="Package {{ i + 1 }}" [toggleable]="true">
                                <ng-template pTemplate="icons">
                                    <button pButton class="p-panel-header-icon p-link" (click)="removePackage(i)">
                                        <span class="pi pi-trash"></span>
                                    </button>
                                </ng-template>
                                <div class="p-grid">
                                    <div class="p-col-4">
                                        <label>Package Type</label>
                                        <liono-treeSelect class="border-bottom-input" [options]="packageType" appendTo="body" formControlName="packageType" selectionMode="single" placeholder="Select Package Type" (onNodeSelect)="onPackageTypeChage(i)"> </liono-treeSelect>
                                    </div>
                                    <div class="p-col-4">
                                        <label>Total Identical Packages</label>
                                        <p-dropdown [options]="packageAmount" appendTo="body" optionLabel="name" dataKey="id" formControlName="totalPackage"></p-dropdown>
                                    </div>
                                    <div class="p-col-4">
                                        <label>UOM</label>
                                        <p-dropdown [options]="massOptions" appendTo="body" optionLabel="name" dataKey="id" formControlName="mass"></p-dropdown>
                                    </div>
                                </div>
                                <div class="p-grid">
                                    <div class="p-col-4">
                                        <label>Weight ({{ getFormGroupAt(i)?.controls?.mass?.value?.name }}) <span style="color: red">*</span></label>
                                        <input pInputText type="text" formControlName="weight" (keypress)="isNumberKey($event)" />
                                    </div>
                                    <div class="p-col-4">
                                        <label>Length (in) <span style="color: red">*</span></label>
                                        <input pInputText type="text" formControlName="length" (keypress)="isNumberKey($event)" />
                                    </div>
                                    <div class="p-col-4">
                                        <label>Width (in) <span style="color: red">*</span></label>
                                        <input pInputText type="text" formControlName="width" (keypress)="isNumberKey($event)" />
                                    </div>
                                </div>
                                <div class="p-grid">
                                    <div class="p-col-4">
                                        <label>Height (in) <span style="color: red">*</span></label>
                                        <input pInputText type="text" formControlName="height" (keypress)="isNumberKey($event)" />
                                    </div>
                                    <div class="p-col-4">
                                        <label
                                            >Total Package Value
                                            <span class="pi pi-exclamation-circle" pTooltip="UPS Covers up to $100 at no charge." tooltipPosition="top"></span>
                                        </label>
                                        <input pInputText type="text" formControlName="packageValue" (keypress)="isNumberKey($event)" />
                                    </div>
                                    <div class="p-col-4">
                                        <label>Reference #1</label>
                                        <input pInputText type="text" formControlName="reference1" />
                                    </div>
                                    <div class="p-col-4">
                                        <label>Reference #2</label>
                                        <input pInputText type="text" formControlName="reference2" />
                                    </div>
                                    <div class="p-col-4" *ngIf="getFormGroupAt(i)?.controls?.cod?.value">
                                        <label>C.O.D Amount</label>
                                        <input pInputText type="text" formControlName="codAmount" />
                                    </div>
                                    <div class="p-col-4" *ngIf="getFormGroupAt(i)?.controls?.cod?.value">
                                        <label>C.O.D Method</label>
                                        <p-dropdown [options]="paymentMethod" appendTo="body" optionLabel="name" dataKey="id" formControlName="codMethod" placeholder="Select Method"> </p-dropdown>
                                    </div>
                                </div>
                                <div class="p-grid">
                                    <div class="p-col-12">
                                        <div class="p-field-checkbox p-mt-3">
                                            <p-checkbox name="group1" value="special" formControlName="includeBatteries" inputId="special" [binary]="true"></p-checkbox>
                                            <div for="special" class="p-ml-2">
                                                <b>Include lithium batteries</b><br />
                                                All lithium ion or lithium metal cell betteries and powered devices.
                                            </div>
                                        </div>
                                        <div class="p-field-checkbox">
                                            <p-checkbox name="group1" value="signature" formControlName="signature" inputId="signature" [binary]="true"></p-checkbox>
                                            <div for="signature" class="p-ml-2">
                                                <b>Signature Options</b><br />
                                                Verify delivery of this shipment.
                                            </div>
                                        </div>
                                        <div class="p-field-checkbox">
                                            <p-checkbox name="group1" value="cod" formControlName="cod" inputId="cod" [binary]="true"></p-checkbox>
                                            <div for="cod" class="p-ml-2">
                                                <b>C.O.D Amount ($)</b><br />
                                                Collect payment from receiver at time of delivery.
                                            </div>
                                        </div>
                                        <!-- <div class="p-field-checkbox">
                                                <p-checkbox name="group1" value="oversize" formControlName="oversizedPackage" inputId="oversize" [binary]="true"></p-checkbox>
                                                <div for="oversize" class="p-ml-2">
                                                    <b>Oversized packages (+$)</b><br>
                                                    Bulky or unpackaged items.
                                                </div>
                                            </div> -->
                                    </div>
                                </div>
                            </p-panel>
                        </div>
                    </ng-container>
                </ng-container>
            </form>
            <div class="p-text-right p-py-3">
                <p-button icon="pi pi-plus" (click)="addPackage()" [disabled]="!form.valid"></p-button>
            </div>
        </div>
        <div class="card" *ngIf="activeIndex == 2">
            <p-table [value]="shipmentRates" responsiveLayout="scroll" selectionMode="single" [(selection)]="selectedService" dataKey="id">
                <ng-template pTemplate="caption">
                    <div>Available Shipping Service Option</div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th>Name</th>
                        <th>Deliver by</th>
                        <th>Cost</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr [pSelectableRow]="product">
                        <td>{{ product.carrier }}&nbsp;{{ product.service }}</td>
                        <td>{{ product.deliverBy }}</td>
                        <td>{{ product.rate | customNumberFormat: fractionDigits}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td></td>
                        <td class="p-text-center" style="display: block">
                            {{ ratesText }}
                        </td>
                        <td></td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <ng-container *ngIf="activeIndex == 3">
            <div class="header">
                <h5>Shipping Address</h5>
            </div>
            <div class="card">
                <div class="p-grid" *ngIf="channel && channel != soChannel.CUSTOMER_RETURNS">
                    <div class="p-col-6">
                        <h6>Ship From</h6>
                        <p>{{ detailsObj?.warehouse?.name }}</p>
                        <p>
                            {{ detailsObj?.warehouse?.address?.streetAddress1 ?? "" }}
                            {{ detailsObj?.warehouse?.address?.streetAddress1 && detailsObj?.warehouse?.address?.streetAddress1?.length > 0 && detailsObj?.warehouse?.address?.streetAddress2 && detailsObj?.warehouse?.address?.streetAddress2.length > 0 ? "," : "" }}
                            {{ detailsObj?.warehouse?.address?.streetAddress2 ?? "" }}
                        </p>
                        <p> {{ detailsObj?.warehouse?.address?.state?.name }}&nbsp;{{ detailsObj?.warehouse?.address?.city?.name }}&nbsp;{{ detailsObj?.warehouse?.address?.zipCode }} </p>
                        <p>
                            {{ detailsObj?.warehouse?.phoneNo }}
                        </p>
                    </div>
                    <div class="p-col-6">
                        <h6>Ship To</h6>
                        <!-- <p>{{ detailsObj?.account?.businessName }}</p> -->
                        <p>{{ shippingAddress?.address?.addressName && shippingAddress?.address?.addressName?.length > 0 ? shippingAddress?.address?.addressName : detailsObj?.account?.businessName }}</p>
                        <p>
                            {{ shippingAddress?.address?.streetAddress1 ?? "" }}
                            {{ shippingAddress?.address?.streetAddress1 && shippingAddress?.address?.streetAddress1?.length > 0 && shippingAddress?.address?.streetAddress2 && shippingAddress?.address?.streetAddress2?.length > 0 ? "," : "" }}
                            {{ shippingAddress?.address?.streetAddress2 ?? "" }}
                        </p>
                        <p> {{ shippingAddress?.address?.state?.name }}&nbsp;{{ shippingAddress?.address?.city?.name }}&nbsp;{{ shippingAddress?.address?.zipCode }} </p>
                        <p> {{ shippingAddressContact?.firstName }} {{ shippingAddressContact?.lastName ? " " : "" }} {{ shippingAddressContact?.lastName }} </p>
                        <p>
                            {{ shippingAddressContact && shippingAddressContact?.contactPhones && shippingAddressContact?.contactPhones[0]?.phone && shippingAddressContact?.contactPhones[0]?.phone?.number ? shippingAddressContact?.contactPhones[0]?.phone?.number : "" }}
                        </p>
                    </div>
                </div>
                <div class="p-grid" *ngIf="channel && channel == soChannel.CUSTOMER_RETURNS">
                    <div class="p-col-6">
                        <h6>Ship From</h6>
                        <!-- <p>{{ detailsObj?.account?.businessName }}</p> -->
                        <p>{{ shippingAddress?.address?.addressName && shippingAddress?.address?.addressName?.length > 0 ? shippingAddress?.address?.addressName : detailsObj?.account?.businessName }}</p>
                        <p>
                            {{ shippingAddress?.address?.streetAddress1 ?? "" }}
                            {{ shippingAddress?.address?.streetAddress1 && shippingAddress?.address?.streetAddress1?.length > 0 && shippingAddress?.address?.streetAddress2 && shippingAddress?.address?.streetAddress2?.length > 0 ? "," : "" }}
                            {{ shippingAddress?.address?.streetAddress2 ?? "" }}
                        </p>
                        <p> {{ shippingAddress?.address?.state?.name }}&nbsp;{{ shippingAddress?.address?.city?.name }}&nbsp;{{ shippingAddress?.address?.zipCode }} </p>
                        <p> {{ shippingAddressContact?.firstName }} {{ shippingAddressContact?.lastName ? " " : "" }} {{ shippingAddressContact?.lastName }} </p>
                        <p>
                            {{ shippingAddressContact && shippingAddressContact?.contactPhones && shippingAddressContact?.contactPhones[0]?.phone && shippingAddressContact?.contactPhones[0]?.phone?.number ? shippingAddressContact?.contactPhones[0]?.phone?.number : "" }}
                        </p>
                    </div>
                    <div class="p-col-6">
                        <h6>Ship To</h6>
                        <p>{{ detailsObj?.warehouse?.name }}</p>
                        <p>
                            {{ detailsObj?.warehouse?.address?.streetAddress1 ?? "" }}
                            {{ detailsObj?.warehouse?.address?.streetAddress1 && detailsObj?.warehouse?.address?.streetAddress1?.length > 0 && detailsObj?.warehouse?.address?.streetAddress2 && detailsObj?.warehouse?.address?.streetAddress2.length > 0 ? "," : "" }}
                            {{ detailsObj?.warehouse?.address?.streetAddress2 ?? "" }}
                        </p>
                        <p> {{ detailsObj?.warehouse?.address?.state?.name }}&nbsp;{{ detailsObj?.warehouse?.address?.city?.name }}&nbsp;{{ detailsObj?.warehouse?.address?.zipCode }} </p>
                        <p>
                            {{ detailsObj?.warehouse?.phoneNo }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="header">
                <h5>Package Details</h5>
            </div>
            <div class="card" *ngFor="let package of form.value.packages; let i = index">
                <div class="p-grid">
                    <div class="p-col-3">
                        <p> <b>Package Type: </b>{{ package?.packageType?.data?.name }} </p>
                        <p> <b>Total identical packages: </b>{{ package?.totalPackage?.name }} </p>
                        <p>
                            <b>Weight: </b>{{ package?.weight }}
                            {{ package?.mass?.name }}
                        </p>
                    </div>
                    <div class="p-col-3">
                        <p><b>Length: </b>{{ package?.length }} in</p>
                        <p><b>Width: </b>{{ package?.width }} in</p>
                        <p><b>Height: </b>{{ package?.height }} in</p>
                    </div>
                    <div class="p-col-3">
                        <p> <b>Total Package Value: </b>{{ package?.packageValue }} </p>
                        <p><b>Reference #1: </b>{{ package?.reference1 }}</p>
                        <p><b>Reference #2: </b>{{ package?.reference2 }}</p>
                    </div>
                    <div class="p-col-3">
                        <p>
                            <b>Include lithium batteries:</b>
                            {{ package?.includeBatteries ? "Yes" : "No" }}
                        </p>
                        <p> <b>Signature Options : </b>{{ package?.signature ? "Yes" : "No" }} </p>
                        <!-- <p><b>C.O.D. (+$) : </b>{{ package?.cod ? 'Yes' : 'No' }}</p> -->
                        <!-- <p>
                            <b>C.O.D Amount ($) : </b>{{
                            package?.cod && package?.codAmount
                            ? package?.codAmount
                            : 0
                            }}
                        </p> -->
                        <p *ngIf="!isVisibleCodField">
                            <b>C.O.D Amount ($) : </b>{{ codAmount | customNumberFormat: fractionDigits }}
                            <span class="p-ml-4 pointer" (click)="showCodField()" *ngIf="getFormGroupAt(i)?.controls?.cod?.value">
                                <i class="pi pi-pencil"></i>
                            </span>
                        </p>
                        <p *ngIf="isVisibleCodField">
                            <b>C.O.D Amount ($) : </b>
                            <p-inputNumber [(ngModel)]="codAmount" [ngModelOptions]="{ standalone: true }" mode="decimal" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits" [style]="{ width: '40%' }" (onBlur)="hideCodField()"> </p-inputNumber>
                        </p>
                    </div>
                </div>
            </div>
            <div class="header">
                <h5>Shipping Service</h5>
            </div>
            <div class="card">
                <div class="p-grid">
                    <div class="p-col-12">
                        <p> <b>Name: </b>{{ selectedService?.carrier }}&nbsp;{{ selectedService?.service }} </p>
                        <p><b>DeliveR BY: </b>{{ selectedService?.deliverBy }}</p>
                        <p *ngIf="!isVisibleShipCostField"
                            ><b>Shipping Cost: </b>{{ shippingCost }}
                            <span class="p-ml-4 pointer" (click)="showShippingCostField()">
                                <i class="pi pi-pencil"></i>
                            </span>
                        </p>
                        <p *ngIf="isVisibleShipCostField"
                            ><b>Shipping Cost: </b>
                            <p-inputNumber [(ngModel)]="shippingCost" [ngModelOptions]="{ standalone: true }" mode="decimal" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits" [style]="{ width: '10%' }" (onBlur)="hideShippingCostField()"> </p-inputNumber>
                        </p>
                        <div class="p-field-checkbox" *ngIf="channel && channel != soChannel.CUSTOMER_RETURNS">
                            <p-checkbox [(ngModel)]="isFreeShipping" [ngModelOptions]="{ standalone: true }" inputId="freeShipping" [binary]="true" (onChange)="changeCODAmount()"></p-checkbox>
                            <div for="freeShipping" class="p-ml-2"> <b>Free Shipping</b><br /> </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    
        <!-- <ng-template pTemplate="footer"> -->
        <div class="p-text-right p-pt-3" style="border-top: 1px solid #ddd">
            <ng-container *ngIf="activeIndex == 0">
                <button type="button" pButton (click)="onDialogClose()" label="Cancel" class="p-button-secondary p-mr-2"></button>
                <button type="button" pButton label="Next" (click)="nextStep(activeIndex)"></button>
            </ng-container>
            <ng-container *ngIf="activeIndex == 1">
                <button type="button" pButton (click)="backStep(activeIndex)" label="Back" class="p-button-secondary p-mr-2"></button>
                <button type="button" pButton label="Next" [disabled]="!form.valid" (click)="nextStep(activeIndex)"></button>
            </ng-container>
            <ng-container *ngIf="activeIndex == 2">
                <button type="button" pButton (click)="backStep(activeIndex)" label="Back" class="p-button-secondary p-mr-2"></button>
                <button type="button" pButton label="Next" [disabled]="!selectedService" (click)="nextStep(activeIndex)"></button>
            </ng-container>
            <ng-container *ngIf="activeIndex == 3">
                <button type="button" pButton (click)="backStep(activeIndex)" label="Back" class="p-button-secondary p-mr-2"></button>
                <button type="button" pButton label="Create Label" (click)="createLabel()" [disabled]="createLabelSubmitted"></button>
            </ng-container>
        </div>
    </div>
    